import { useStaticQuery, graphql } from 'gatsby';

const useCompany = () => {
  const { strapi } = useStaticQuery(graphql`
    query CompanyQuery {
      strapi {
        company {
          name
          email
          tel
          tel2
          street
          houseNumber
          postcode
          postalCode: postcode
          city
          kvk
          btw

          logo {
            name
            url
            width
            height
            imageFile {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, width: 320, quality: 100, placeholder: BLURRED)
              }
            }
          }

          image {
            name
            url
            width
            height
            imageFile {
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, width: 800, quality: 100, placeholder: BLURRED)
              }
            }
          }

        }
      }
    }
  `);

  return strapi.company;
};

export default useCompany;
